<template>
  <LoaderIndicator v-if="carregando" :notFound="notFound" :full="true" />
  <Menuooloja />

  <div class="flex items-center justify-between px-4 pb-1 pt-1">
    <Breadcrumbs :items="itemsBreadCrumbs" />
  </div>

  <div class="ooloja-card-default">
    <div class="ooloja-card-default__header">
      <div class="flex w-full items-center justify-between">
        <h2>Dashboard</h2>
        <div>
          <ElButton :icon="Setting" @click="abreConfiguracoes"> Configurações </ElButton>
        </div>
      </div>
    </div>
    <div class="ooloja-card-default__body">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 mb-5">
        <MetricCard title="Transações" :value="numero_transacoes" :subtitle="`total de ${formatCurrency(gastoTotal)}`"
          icon="teenyicons:money-outline" />
        <MetricCard title="Usuários" :value="usuarios_ativos" icon="mynaui:user-waves" :usuarios="usuariosMetrics" />
        <MetricCard title="Usuários Compradores" :value="usuarios_compradores" icon="clarity:users-outline-badged" />
        <MetricCard title="Carrinhos Ativos" :value="carrinhos_ativos"
          icon="material-symbols-light:garden-cart-outline-rounded" />
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-5">
        <DashboardUsers :usuarios_top10="usuarios_top10" />
        <DashboardABCCurve :dados="dadosABC" />
      </div>

      <div class="mb-5">
        <DashboardInactiveUsers v-if="dadosUsuariosInativos90" :usuarios-inativos="dadosUsuariosInativos90" />
      </div>

      <div class="mb-5">
        <DashboardTicketMedio :ticket-medio-data="ticketMedioData" />
      </div>

      <div class="mb-5">
        <DashboardClienteTicketMedio :ticket-medio-data="ticketMedioDataCliente" />
      </div>
    </div>
    <div class="ooloja-card-default__footer"></div>
  </div>
  <div class="min-h-[15px]"></div>
</template>

<script setup>
definePageMeta({
  layout: "ooloja",
});

import DashboardUsers from "@/components/Dashboard/users.vue";
import DashboardABCCurve from "@/components/Dashboard/DashboardABCCurve.vue";
import DashboardInactiveUsers from "@/components/Dashboard/DashboardInactiveUsers.vue";
import DashboardTicketMedio from "@/components/Dashboard/DashboardTicketMedio.vue";
import DashboardClienteTicketMedio from "@/components/Dashboard/DashboardClienteTicketMedio.vue";
import MetricCard from "@/components/Dashboard/MetricCard.vue";
import { Setting } from "@element-plus/icons-vue";
import Menuooloja from "./menuooloja.vue";
import { toast } from "vue3-toastify";

import { useUserStore } from "~/stores/usuario_store";
const userStore = useUserStore();

const permissoes = ref({});
const usuarioTipo = ref("");
const notFound = ref(false);

const gastoTotal = ref(0);
const numero_transacoes = ref(0);
const usuarios_cadastrados = ref(0);
const usuarios_ativos = ref(0);
const usuarios_inativos = ref(0);
const usuarios_aguardando_documentacao = ref(0);
const usuarios_compradores = ref(0);
const carrinhos_ativos = ref(0);
const usuarios_top10 = ref([]);
const dadosABC = ref([]);
const dadosUsuariosInativos90 = ref([]);
const ticketMedioData = ref([]);
const ticketMedioDataCliente = ref([]);

const carregando = ref(false);

async function getDados(pageNum = 1) {
  carregando.value = true;
  try {
    // dados dos usuarios
    await useAPI
      .get(`/ooloja/get-geral/?ac=dashboard`)
      .then(({ data }) => {
        gastoTotal.value = data.gasto_total || 0;
        numero_transacoes.value = data.numero_transacoes || 0;
        usuarios_cadastrados.value = data.usuarios_cadastrados || 0;
        usuarios_ativos.value = data.usuarios_ativos || 0;
        usuarios_inativos.value = data.usuarios_inativos || 0;
        usuarios_aguardando_documentacao.value =
          data.usuarios_aguardando_documentacao || 0;
        usuarios_compradores.value = data.usuarios_compradores || 0;
        carrinhos_ativos.value = data.carrinhos_ativos || 0;
        usuarios_top10.value = data.clientes_top10 || [];
      });

    // Curva ABC
    await useAPI
      .get(`/ooloja/get-produto-curva-abc/?ac=dashboard`)
      .then(({ data }) => {
        dadosABC.value = data.dados;
      });

    //Usuario inativos por mais de 60 dias (compras)
    await useAPI
      .get(`/ooloja/get-usuarios-inativo90/?ac=dashboard`)
      .then(({ data }) => {
        dadosUsuariosInativos90.value = data.dados;
      });

    //Ticket Medio
    await useAPI
      .get(
        `/ooloja/get-produto-top10-ticketmedio/?ac=dashboard`,
        await userStore.user.token
      )
      .then(({ data }) => {
        ticketMedioData.value = data.dados;
      });

    //Ticket Medio Cliente
    await useAPI
      .get(
        `/ooloja/get-clientes-top10-ticketmedio/?ac=dashboard`,
        await userStore.user.token
      )
      .then(({ data }) => {
        ticketMedioDataCliente.value = data.dados;
      });
  } catch (error) {
    toast.error("Erro ao carregar dados do dashboard", { autoClose: 3000 });
    notFound.value = true;
  } finally {
    carregando.value = false;
  }
}

const itemsBreadCrumbs = [
  {
    title: "OOLoja",
    disabled: true,
  },
];

async function getPermissoes() {
  permissoes.value = await getPermissoesComponent(
    userStore.user.usuario.perfil.toLowerCase(),
    "ooloja"
  );
}

const abreConfiguracoes = () => {
  navigateTo("/ooloja/configuracoes");
};

// Computed para o array de usuários
const usuariosMetrics = computed(() => [
  { label: "Inativos", value: usuarios_inativos.value },
  { label: "Aguardando", value: usuarios_aguardando_documentacao.value },
  { label: "Total", value: usuarios_cadastrados.value },
]);

onMounted(() => {
  getDados();
  getPermissoes();
  usuarioTipo.value = userStore.user.usuario.tipo;
});

// Formatar valores monetários
const formatCurrency = (value) => {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value);
};
</script>

<style></style>
